import { useRouterState } from '@tanstack/react-router';

export default function useLocationHash(omitHashMark?: boolean) {
  const {
    location: { hash },
  } = useRouterState();
  return omitHashMark ? hash : `#${hash}`;
}
